class Workshop {
  constructor(
    id,
    name,
    slug,
    country,
    city,
    street,
    streetNumber,
    postcode,
    latitude,
    longitude,
    website,
    description,
    numberOfReviews,
    averageRate,
    active,
    isOwner,
    image,
  ) {
    this.id = id;
    this.name = name;
    this.slug = slug;
    this.country = country;
    this.city = city;
    this.street = street;
    this.streetNumber = streetNumber;
    this.postcode = postcode;
    this.latitude = parseFloat(latitude);
    this.longitude = parseFloat(longitude);
    this.website = website;
    this.description = description;
    this.numberOfReviews = numberOfReviews;
    this.averageRate = averageRate;
    this.active = active;
    this.isOwner = isOwner;
    this.image = image;
  }
}

export default Workshop;
